import Highcharts from "highcharts";
import moment from "../../../common/moment";
import store from "../../../common/store";
import * as queryUtil from "../../../common/query";
import * as consts from "../../../common/const";
// moment().locale('zh-cn')
// 目标与增长
const log = console.log.bind(console)

const chartColumn = function(result, columnSize) {
    log('result is ', result)
  columnSize = columnSize || 60;
  return {
    chart: {
      type: "column",
      panning: true,
      panKey: "shift",
      zoomType: "x"
    },
    xAxis: result.xAxis || [],
    yAxis: result.yAxis || [],
    tooltip: {
      headerFormat: `
        <ul class="pointTable">
          <li class="flex-nowrap flex-between">
            <div><small>{point.key}</small></div>
            <div><small>${store.state.setIndexName}</small></div>
          </li>
      `,
      pointFormatter: function() {
        if (typeof result.util === "undefined") {
          return `
            <li class="flex-nowrap flex-around">
              <div class="width-full" style="color: ${this.series.color};line-height:20px;padding-right: 10px;">
                <span style="padding-right: 4px">\u25CF</span>
                <span>${this.series.name}</span>
              </div>
              <div><b>${this.y}</b></div>
            </li>
          </ul>
        `;
        } else {
          // 百分比单位
          return `
            <li class="flex-nowrap flex-around">
              <div class="width-full" style="color: ${
                this.series.color
              };line-height:20px;padding-right: 10px;">
                <span style="padding-right: 4px">\u25CF</span>
                <span>${this.series.name}</span>
              </div>
              <div><b>${this.y}${result.util[this.series.name]}</b></div>
            </li>
          </ul>
          `;
        }
      }
    },
    plotOptions: {
      // column: {
      //   pointWidth: 15,
      //   groupPadding: 0.25,
      //   borderWidth: 0,
      //   states: {
      //     hover: {
      //       animation: {
      //         duration: 2000
      //       }
      //     }
      //   }
      // }
    },
    series: result.series || []
  };
};

const wordCloudChart = function(result, columnSize) {
    return result
};
const treeChart = function(result, columnSize) {
    return result
};
// 全柱状
const chartColumnOne = function(result) {
  return {
    chart: {
      type: "column"
    },
    xAxis: result.xAxis || [],
    yAxis: result.yAxis || [],
    tooltip: {
      headerFormat: `<table class="pointTable" style="width: 180px;margin-left:-15px">
      <tr class="pointTitle">
      <td class="tl"><small>{point.key}</small></td>
      <td class="tr"><small></small></td>
      </tr>
      `,
      //       <td class="tr"><small>${result.name || '现金流'}</small></td>
      pointFormatter: function() {
        return `
        <tr>
          <td style="color: ${this.series.color};line-height:20px;padding-right: 10px">
            <span style="padding-right: 4px">\u25CF</span>
            <span>${this.series.name}</span>
          </td>
          <td class="tr"><b>${this.y}</b></td>
        </tr>
        `;
      }
    },
    plotOptions: {
      column: {
        pointWidth: 20
      }
    },
    series: result.series || []
  };
};

// 无数据图表
const chartBlank = function() {
  return {
    chart: {
      type: "spline"
    },
    xAxis: {},
    yAxis: {},
    series: []
  };
};

// 曲线
const chartSpline = function(result) {
  return {
    chart: {
      type: "areaspline"
    },
    xAxis: result.xAxis || [],
    yAxis: result.yAxis || [],
    tooltip: {
      shared: true,
      headerFormat: ``,
      pointFormatter: function() {
        if (result.xAxis.value[0].indexOf("/") >= 0) {
          return `
            <table class="tableChart" style="width: 210px; margin-left:-15px;margin-right: 0px">
            <tr>
              <td><small>${result.xAxis.value[this.x]}</small></td>
            </tr>
            <tr>
              <td style="color: ${
                this.series.color
              };line-height:20px;padding-right: 10px;">
                <span style="padding-right: 4px">\u25CF</span>
                <span>${this.series.name}</span>
              </td>
              <td style="width: 20px" class="tr"><b>${this.y}${
            result.util[this.series.name]
          }</b></td>
            </tr>
            `;
        }
        return `
        <table class="tableChart" style="width: 210px; margin-left:-15px;margin-right: 0px">
          <tr>
            <td><small>${result.xAxis.value[this.x]} （${moment(
          result.xAxis.value[this.x]
        ).format("dddd")}）</small></td>
          </tr>
          <tr>
            <td style="color: ${
              this.series.color
            };line-height:20px;padding-right: 10px;">
              <span style="padding-right: 4px">\u25CF</span>
              <span>${this.series.name}</span>
            </td>
            <td style="width: 20px" class="tr"><b>${this.y}${
          result.util[this.series.name]
        }</b></td>
          </tr>
        `;
      }
    },
    plotOptions: {
      series: {
        fillOpacity: 0.3
      }
    },
    series: result.series || []
  };
};

// 对比曲线
const chartContrastSpline = function(result, index) {
  let title = consts.chartPointTitle[index] || "";
  let i = 0;
  if (title === "时间") {
    return {
      chart: {
        type: "areaspline"
      },
      xAxis: result.xAxis || [],
      yAxis: result.yAxis || [],
      tooltip: {
        shared: true,
        backgroundColor: "#FFF", // 背景颜色
        style: {
          opacity: 1
        },
        headerFormat: `
          <ul class="pointTable">
            <li class="flex-nowrap flex-between">
              <div><small>${title}</small></div>
              <div><small>${store.state.setIndexName}</small></div>
            </li>
        `,
        pointFormatter: function() {
          i++;
          return `
            <li class="flex-nowrap flex-around">
              <div class="width-full" style="color: ${
                this.series.color
              };line-height:20px;padding-right: 10px;">
                <span style="padding-right: 4px">\u25CF</span>
                <span>${
                  result.xAxis.value[this.x].indexOf("与") >= 0
                    ? result.xAxis.value[this.x].split("与")[
                        i % 2 === 1 ? 0 : 1
                      ]
                    : result.xAxis.value[this.x]
                }</span>
              </div>
              <div><b>${this.y}${result.util[this.series.name]}</b></div>
            </li>
          </ul>
          `;
        }
      },
      // <span>${this.x}</span>
      // <span>${result.xAxis.value[this.x].split('与')[(i % 2 === 1 ? 1 : 0)]}</span>
      plotOptions: {
        series: {
          fillOpacity: 0.3
        }
      },
      series: result.series || []
    };
  } else {
    return {
      chart: {
        type: "areaspline"
      },
      xAxis: result.xAxis || [],
      yAxis: result.yAxis || [],
      tooltip: {
        shared: true,
        headerFormat: ``,
        pointFormatter: function() {
          return `
            <ul class="pointTable">
              <li class="pointTitle flex-nowrap flex-between">
                <div class="title"><small>${title}（${
            result.xAxis.value[this.x]
          }）</small></div>
                <div><small>${store.state.setIndexName}</small></div>
              </li>
              <li class="flex-nowrap flex-around">
                <div class="width-full" style="color: ${
                  this.series.color
                };line-height:20px;padding-right: 10px;">
                  <span style="padding-right: 4px">\u25CF</span>
                  <span>${this.series.name}</span>
                </div>
                <div><b>${this.y}${result.util[this.series.name]}</b></div>
              </li>
            </ul>
            `;
        }
      },
      plotOptions: {
        series: {
          fillOpacity: 0.3
        }
      },
      series: result.series || []
    };
  }
};

// 饼图
const chartPie = function(result) {
  let i = 0;
  return {
    chart: {
      width: 480,
      height: 260,
      type: "pie"
    },
    // title: {
    //   floating: true,
    //   text: result ? '项目' : '',
    //   style: {'fontSize': '14px'}
    // },
    legend: {
      layout: "vertic",
      verticalAlign: "middle",
      align: "right",
      itemDistance: 100
    },
    tooltip: {
      headerFormat: `<table style="width: 180px;margin-left:-15px">
        <tr><td><b>{point.key}</b></td></tr>
        <tr>
          <td style="line-height:20px;padding-right: 10px">
            <span style="padding-right: 4px"></span>
            <span>{series.name}</span>
          </td>
          <td class="tr"><b>{point.percentage:.1f}%</b></td>
        </tr>`,
      pointFormatter: function() {
        return `
            <tr>
              <td style="line-height:20px;padding-right: 10px">
                <span style="padding-right: 4px"></span>
                <span>${store.state.setIndexName}</span>
              </td>
              <td class="tr"><b>${this.y}</b></td>
            </tr>
            `;
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        showInLegend: true,
        dataLabels: {
          enabled: true,
          padding: 0,
          distance: 5,
          formatter: function() {
            i++;
            if (this.percentage > 0 && i <= 4) {
              return this.percentage.toFixed(1) + " %";
            }
          }
        },
        point: {
          events: {
            legendItemMouse: function() {
              var visibility = this.visible ? "visible" : "hidden";
              if (
                !confirm(
                  "The series is currently " +
                    visibility +
                    ". Do you want to change that?"
                )
              ) {
                return false;
              }
            },
            mouseOver(e) {
              // 鼠标滑过时动态更新标题
              this.slice();
              e.target.series.chart.setTitle({
                text: ""
                // e.target.name
                // e.target.name + '\t' + e.target.y + ' RMB'
              });
            },
            mouseOut: function() {
              this.slice();
            },
            click(e) {
              store.commit({
                type: "getPieIndex",
                index: e.point.index
              });
            }
          }
        },
        slicedOffset: 6
      }
    },
    series: [
      {
        size: "210",
        innerSize: "160", // 内径
        name: "占比：",
        data: result
      }
    ]
  };
};

// 无事件饼图
const chartPie2 = function(result, size) {
  let i = 0;
  return {
    chart: size || {
      width: 420,
      height: 260,
      type: "pie"
    },
    legend: {
      enabled: true,
      layout: "vertic",
      verticalAlign: "middle",
      align: "right",
      itemDistance: 100
    },
    tooltip: {
      headerFormat: `<table style="width: 180px;margin-left:-15px">
        <tr><td><b>{point.key}</b></td></tr>
        <tr>
          <td style="line-height:20px;padding-right: 10px">
            <span style="padding-right: 4px"></span>
            <span>{series.name}</span>
          </td>
          <td class="tr"><b>{point.percentage:.1f}%</b></td>
        </tr>`,
      pointFormatter: function() {
        return `
            <tr>
              <td style="line-height:20px;padding-right: 10px">
                <span style="padding-right: 4px"></span>
                <span>${store.state.setIndexName}</span>
              </td>
              <td class="tr"><b>${this.y}</b></td>
            </tr>
            `;
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        showInLegend: true,
        dataLabels: {
          enabled: true,
          padding: 0,
          distance: 5,
          formatter: function() {
            i++;
            if (this.percentage > 0 && i <= 4) {
              return this.percentage.toFixed(1) + " %";
            }
          }
        },
        point: {
          events: {
            legendItemMouse: function() {
              var visibility = this.visible ? "visible" : "hidden";
              if (
                !confirm(
                  "The series is currently " +
                    visibility +
                    ". Do you want to change that?"
                )
              ) {
                return false;
              }
            },
            mouseOver(e) {
              // 鼠标滑过时动态更新标题
              this.slice();
              e.target.series.chart.setTitle({
                text: ""
                // e.target.name
                // e.target.name + '\t' + e.target.y + ' RMB'
              });
            },
            mouseOut: function() {
              this.slice();
            }
          }
        },
        slicedOffset: 6
      }
    },
    series: [
      {
        size: "210",
        innerSize: "160", // 内径
        name: "占比：",
        data: result
      }
    ]
  };
};
const colors = store.state.colors;
// 趋势 + 饼图
const chartPieTrend = function(result, size) {
//   console.log(result);
  let i = 0;
  // tjr添加，颜色与通标一致
  let colorObj = store.state.colorObj;

  let eachColor = [];
  if (Object.keys(colorObj).length === 0) {
    result.forEach((item, index) => {
      colorObj[item[0]] = colors[index];
    });
    store.state.colorObj = colorObj;
  }
  result.forEach((item, index) => {
    for (let i in colorObj) {
      if (item[0] === i) {
        eachColor.push(colorObj[i]);
      }
    }
  });
  store.state.eachColor = eachColor;
  // console.log(store.state.eachColor, 1)

  // result = result.slice(3);
  // console.log(result);
  return {
    colors: store.state.eachColor,
    chart: {
      type: "pie",
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false
    },
    tooltip: {
      headerFormat: `<table style="width: 180px;margin-left:-15px">
        <tr><td><b>{point.key}</b></td></tr>
        <tr>
          <td style="line-height:20px;padding-right: 10px">
            <span style="padding-right: 4px"></span>
            <span>{series.name}</span>
          </td>
          <td class="tr"><b>{point.percentage:.1f}%</b></td>
        </tr>`,
      pointFormatter: function() {
        return `
            <tr>
              <td style="line-height:20px;padding-right: 10px">
                <span style="padding-right: 4px"></span>
                <span>${store.state.setIndexName}</span>
              </td>
              <td class="tr"><b>${this.y}</b></td>
            </tr>
            `;
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          padding: 0,
          distance: 5,
          formatter: function() {
            i++;
            if (this.percentage > 0 && i <= 4) {
              return this.percentage.toFixed(1) + " %";
            }
          }
        },
        point: {
          events: {
            mouseOver: function() {
              this.slice();
            },
            mouseOut: function() {
              this.slice();
            }
          }
        },
        slicedOffset: 6
      }
    },
    lang: {
      noData: "暂无数据"
    },
    noData: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        color: "#CCCCCC"
      }
    },
    series: [
      {
        size: "210",
        innerSize: "160", // 内径
        name: "占比：",
        data: result
      }
    ]
  };
};

// 曲线 饼图 + 趋势图 趋势图
const chartSplineTrend = function(result) {

  let colorObj = store.state.colorObj;
//   console.log(colorObj)
//   console.log(result)
  let eachColor = [];
  if (Object.keys(colorObj).length === 0) {
    result.series.forEach((item, index) => {
      colorObj[item.name] = colors[index];
    });
    store.state.colorObj = colorObj;
  }
//   console.log("result.series=>",result.series);
//   console.log("colorObj=>",colorObj)
  result.series.forEach(item => {
    for (let i in colorObj) {
      if (item.name === i) {
        eachColor.push(colorObj[i]);
      }
    }
  });
  store.state.eachColor = eachColor;
//   console.log(store.state.eachColor, 2)
  return {
    chart: {
      type: "areaspline"
    },
    legend: {
      x: -420 / 2,
      itemDistance: 100,
      verticalAlign: "bottom",
      align: "center",
      enabled: false
    },
    colors: store.state.eachColor,
    xAxis: result.xAxis || [],
    yAxis: result.yAxis || [],
    tooltip: {
      headerFormat: ``,
      pointFormatter: function() {
        return `
        <ul class="pointTable">
          <li class="pointTitle flex-nowrap flex-between">
            <div class="title"><small>（${
              result.xAxis.value[this.x]
            }）</small></div>
            <div><small>${store.state.setIndexName}</small></div>
          </li>
          <li class="flex-nowrap flex-around">
            <div class="width-full" style="color: ${
              this.series.color
            };line-height:20px;padding-right: 10px;">
              <span style="padding-right: 4px">\u25CF</span>
              <span>${this.series.name}</span>
            </div>
            <div><b>${this.y}</b></div>
          </li>
        </ul>
        `;
      }
    },
    plotOptions: {
      spline: {
        marker: {
          enabled: false
        }
      },
      series: {
        fillOpacity: 0.3,
        enabled: false
      }
    },
    series: result.series || []
  };
};

// 桑基图
const chartSangKeyTrend = function(result, name) {
  if (name === "ProjectProgress") {
    return {
      chart: {
        height: 1200
      },
      series: [
        {
          keys: ["from", "to", "weight"],
          data: result,
          type: "sankey",
          name: ""
        }
      ]
    };
  } else {
    return {
      chart: {
        height: 550
      },
      series: [
        {
          keys: ["from", "to", "weight"],
          data: result,
          type: "sankey",
          name: ""
        }
      ]
    };
  }
};

// 词云图
const chartWordCloud = function(result) {
  var data = result.split(/[,\. ]+/g).reduce(function(arr, word) {
    var obj = arr.find(function(obj) {
      return obj.name === word;
    });
    if (obj) {
      obj.weight += 1;
    } else {
      obj = {
        name: word,
        weight: 1
      };
      arr.push(obj);
    }
    return arr;
  }, []);
  return {
    credits: {
      enabled: false
    },
    series: [
      {
        data: data,
        type: "wordcloud"
      }
    ]
  };
};

const heatchart = function(result, title, name, colors) {
  name = name || "";
  colors = colors || {
    minColor: "#FFeFeF",
    maxColor: "#FF5657"
  };
  return {
    chart: {
      type: "heatmap",
      height: 550,
      plotBorderWidth: 1
    },
    title: {
      text: "",
      verticalAlign: "bottom",
      y: 0
    },
    xAxis: {
      categories: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      opposite: true
    },
    yAxis: {
      categories: consts.TIMEHOUR.sort(function(x, y) {
        // return y.split(':').join('') - x.split(':').join('')
        return y;
      }),
      title: null
    },
    colorAxis: {
      // min: 0,
      minColor: colors.minColor,
      maxColor: colors.maxColor
    },
    legend: {
      align: "right",
      layout: "vertical",
      margin: 0,
      verticalAlign: "top",
      y: 25,
      symbolHeight: 730
    },
    tooltip: {
      formatter: function() {
        // console.log(title)
        if (title === "Productivity") {
          return (
            "<b>" +
            this.series.xAxis.categories[this.point.x] +
            "</b>  <br><b>" +
            this.series.yAxis.categories[this.point.y] +
            "</b> <br><b>" +
            name +
            " ：" +
            this.point.value +
            "%" +
            "</b>"
          );
        } else {
          return (
            "<b>" +
            this.series.xAxis.categories[this.point.x] +
            "</b>  <br><b>" +
            this.series.yAxis.categories[this.point.y] +
            "</b> <br><b>" +
            name +
            " ：" +
            this.point.value +
            "</b>"
          );
        }
      }
    },
    series: [
      {
        name: "",
        borderWidth: 1,
        maxPointWidth: 10,
        // borderColor: '#E9E9F0',
        borderColor: "white",
        data: result,
        dataLabels: {
          enabled: true,
          color: "#333",
          formatter: function() {
            if (title === "Productivity") {
              return this.point.value + "%";
            } else {
              return this.point.value;
            }
          }
        }
      }
    ]
  };
};

// 漏斗图
const chartFunnel = function(result, name) {
  return {
    chart: {
      // type: "funnel"
      type: "funnel3d",
      width: result.width ? result.width : 800,
      height: result.height ? result.height : undefined,
      options3d: {
        enabled: true,
        alpha: 10,
        depth: 50,
        viewDistance: 50
      }
    },
    // plotOptions: {
    //   series: {
    //     dataLabels: {
    //       enabled: true,
    //       crop: false,
    //       overflow: "none",
    //       format: "<b>{point.name}</b> ({point.y:,.0f})",
    //       color:
    //         (Highcharts.theme && Highcharts.theme.contrastTextColor) || "black",
    //       softConnector: true
    //     },
    //     neckWidth: "30%",
    //     neckHeight: "25%"
    //   }
    // },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b> ({point.y:,.0f})",
          color:
            (Highcharts.theme && Highcharts.theme.contrastTextColor) || "black",
          allowOverlap: true,
          y: 10
        },
        neckWidth: "30%",
        neckHeight: "25%",
        width: "80%",
        height: "80%"
      }
    },
    legend: {
      enabled: false
    },
    series: [
      {
        name: result.name,
        data: result.data
      }
    ]
  };
  // } else {
  //   return {
  //     chart: {
  //       height: 550
  //     },
  //     series: [{
  //       keys: ['from', 'to', 'weight'],
  //       data: result,
  //       type: 'sankey',
  //       name: ''
  //     }]
  //   }
  // }
};
let xy = {};

export {
  chartBlank,
  chartColumn,
  wordCloudChart,
  treeChart,
  chartColumnOne,
  chartSpline,
  chartContrastSpline,
  chartPie,
  chartPie2,
  chartPieTrend,
  chartSplineTrend,
  heatchart,
  xy,
  chartSangKeyTrend,
  chartWordCloud,
  chartFunnel
};
